import { render, staticRenderFns } from "./OrderChooseInsurance.vue?vue&type=template&id=34bf98a8&"
import script from "./OrderChooseInsurance.vue?vue&type=script&lang=js&"
export * from "./OrderChooseInsurance.vue?vue&type=script&lang=js&"
import style0 from "./OrderChooseInsurance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports